<template>
  <div>
    <div class="mb-8 flex justify-start max-w-3xl">
      <h1 class="font-bold text-3xl">
        <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('applicationbuy')">Regresar</inertia-link>
        <span class="text-indigo-400 font-medium">/</span>
        Editar Solicitud
      </h1>
     
    </div>
    <div class="flex flex-wrap">
    <div class="w-full">
      <ul class="flex mb-0 list-none flex-wrap pt-3 pb-4 flex-row">
        <li class="-mb-px mr-2 last:mr-0 flex-auto text-center">
          <a class="text-xs font-bold uppercase px-5 py-3 shadow-lg rounded block leading-normal" v-on:click="toggleTabs(1)" v-bind:class="{'text-amber-600 bg-white': openTab !== 1, 'text-black bg-amber-600': openTab === 1}">
           Ficha Principal
          </a>
        </li>
        <li  class="-mb-px mr-2 last:mr-0 flex-auto text-center">
          <a class="text-xs font-bold uppercase px-5 py-3 shadow-lg rounded block leading-normal" v-on:click="toggleTabs(2)" v-bind:class="{'text-amber-600 bg-white': openTab !== 2, 'text-black bg-amber-600': openTab === 2}">
           Fiscalización
          </a>
        </li>
        <li v-if="$page.props.auth.user.rol =='Bodega' && form.tracking=='Aprobado'" class="-mb-px mr-2 last:mr-0 flex-auto text-center">
          <a class="text-xs font-bold uppercase px-5 py-3 shadow-lg rounded block leading-normal" v-on:click="toggleTabs(6)" v-bind:class="{'text-amber-600 bg-white': openTab !== 6, 'text-black bg-amber-600': openTab === 6}">
           Bodega
          </a>
        </li>
        <li v-if="$page.props.auth.user.rol =='Contabilidad' && form.tracking=='Subido'" class="-mb-px mr-2 last:mr-0 flex-auto text-center">
          <a class="text-xs font-bold uppercase px-5 py-3 shadow-lg rounded block leading-normal" v-on:click="toggleTabs(3)" v-bind:class="{'text-amber-600 bg-white': openTab !== 3, 'text-black bg-amber-600': openTab === 3}">
           Contabilidad
          </a>
        </li>
        <li v-if="$page.props.auth.user.rol =='Financiero'" class="-mb-px mr-2 last:mr-0 flex-auto text-center">
          <a class="text-xs font-bold uppercase px-5 py-3 shadow-lg rounded block leading-normal" v-on:click="toggleTabs(4)" v-bind:class="{'text-amber-600 bg-white': openTab !== 4, 'text-black bg-amber-600': openTab === 4}">
           Financiero
          </a>
        </li>
        <li v-if="$page.props.auth.user.rol =='Archivo'" class="-mb-px mr-2 last:mr-0 flex-auto text-center">
          <a class="text-xs font-bold uppercase px-5 py-3 shadow-lg rounded block leading-normal" v-on:click="toggleTabs(5)" v-bind:class="{'text-amber-600 bg-white': openTab !== 5, 'text-black bg-amber-600': openTab === 5}">
           Archivo
          </a>
        </li>
      </ul>
      <div class="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded">
        <div class="px-4 py-5 flex-auto">
          <div class="tab-content tab-space">
            <div v-bind:class="{'hidden': openTab !== 1, 'block': openTab === 1}">
              <form @submit.prevent="update">
                <div class="flex flex-wrap -mb-8 -mr-6 p-8">
                  <text-input v-model="form.id" :error="form.errors.id" :req="form.id" class="pb-8 pr-6 w-full lg:w-1/6" label="N°" disabled/>   
                <div class="container pb-8 pr-6 w-full lg:w-1/6">
                <label class="form-label" >Empresa:</label>
            <v-select v-model="form.organization_id" :options="organizationes" label="tradename"></v-select>
            </div>
            <div class="container pb-8 pr-6 w-full lg:w-1/6">
            <label class="form-label" >Proveedor:</label>
            <v-select v-model="form.contact_id" :options="contactos"  label="nid"></v-select>
            </div>   
            <div v-if="form.status_application=='Mecanica'" class="container pb-8 pr-6 w-full lg:w-2/6">
            <label class="form-label" >Activo:</label>
            <v-select v-model="form.machinery_id" :options="machineryss"  label="name"></v-select>
            </div>  
            <div class="container pb-8 pr-6 w-full lg:w-1/6">
            <label class="form-label" >Fecha </label>
          <date-picker v-model="form.fecha"  :placeholder="form.fecha" ></date-picker>
          </div>
              <text-input v-model="form.number" :error="form.errors.number" :req="form.number" class="pb-8 pr-6 w-full lg:w-1/6" label="Nº Factura" required/>   
              <text-input v-model="form.total" :error="form.errors.total" :req="form.total" class="pb-8 pr-6 w-full lg:w-1/6" label="V. Total" required/>         
             
              <text-input v-if="form.status_application=='Mecanica'" v-model="form.kilometraje" :error="form.errors.kilometraje" :req="form.kilometraje" class="pb-8 pr-6 w-full lg:w-1/6" label="Kilometraje" required/>   

         <file-input v-model="form.foto_url" :error="form.errors.foto_url" :req="form.foto_url" class="pb-8 pr-6 w-full lg:w-2/6" type="file" label="Respaldos" required/>
        <!--  <img v-bind:src="photo" width="90" height="90" alt="">-->
        <select-input v-model="form.tipo_pago" :error="form.errors.tipo_pago" class="pr-6 pb-8 w-full lg:w-1/6" label="Pago Urgente" required>
                  <option>NO</option>
                  <option>SI</option>
                   </select-input>
        <textarea-input v-model="form.detalle" :error="form.errors.detalle" :req="form.detalle" class="pb-8 pr-6 w-full lg:w-4/6" label="Detalle" required />
       
        <a v-if="form.file_url" :href="form.file_url">Ver archivos</a>
         </div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <inertia-link  class="btn-indigo3" :href="route('applicationbuy.editCost',form2.id)">
                  <span>Modificar</span>
                  <span class="hidden md:inline"> Precios</span>
                </inertia-link>        
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">Actualizar Solicitud</loading-button>
        </div>
              </form>
            </div>
            <div v-bind:class="{'hidden': openTab !== 2, 'block': openTab === 2}">
            <form @submit.prevent="updateFiscalizado">
                <div class="flex flex-wrap -mb-8 -mr-6 p-8">
               
                <textarea-input v-model="form2.detalle" :error="form2.errors.detalle" :req="form2.detalle" class="pb-8 pr-6 w-full lg:w-4/6" label="Observación" required />
                <file-input v-model="form2.foto_url" :error="form2.errors.foto_url" :req="form.foto2_url" class="pb-8 pr-6 w-full lg:w-2/6" type="file" label="Respaldos" required/>
                <a v-if="form2.file_url_fiscalizado" :href="form2.file_url_fiscalizado">Ver archivos</a>         
                  </div>
              <div v-if="form.tracking=='Fiscalizado' && $page.props.auth.user.rol =='Compras' && form.status_application=='Compras'" class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
                <loading-button :loading="form2.processing" class="btn-indigo" type="submit">Guardar respaldo firmado</loading-button>
              </div>
            </form>
            <br>
            <br>
            <br>
            <inertia-link v-if="$page.props.auth.user.rol =='Compras' && form.tracking=='Fiscalizado'" class="btn-indigo" :href="route('applicationbuy.editFiscalizadoImprimir',form.id)">
              <span>Imprimir</span>
              <span class="hidden md:inline">Documento</span>
            </inertia-link>
            <inertia-link v-if="$page.props.auth.user.rol =='Fiscalizador' && form.tracking=='Solicitado'" class="btn-indigo" :href="route('applicationbuy.editFiscalizado',form.id)">
              <span>Aprobar &</span>
              <span class="hidden md:inline">Fiscalizar</span>
            </inertia-link>
            </div>
            <div v-bind:class="{'hidden': openTab !== 3, 'block': openTab === 3}">
              <form @submit.prevent="updateContablilidad">
                <div class="flex flex-wrap -mb-8 -mr-6 p-8">
                  <select-input v-model="form3.tipo_destino" :req="form3.tipo_destino" :error="form3.errors.tipo_destino" class="pr-6 pb-8 w-full lg:w-1/6" label="Destino" required>
                <option>Pago Inmediato</option>
                <option>Archivo</option>
              </select-input>
                  <text-input v-model="form3.total_pagar" :error="form3.errors.total_pagar" :req="form3.total_pagar" :placeholder="form.total_pagar" class="pb-8 pr-6 w-full lg:w-1/6" label="Valor a Pagar" required/>   
                <textarea-input v-model="form3.detalle_contable" :error="form3.errors.detalle_contable" :req="form3.detalle_contable" class="pb-8 pr-6 w-full lg:w-4/6" label="Observación" />
                <br>
                <a :href="form.file_url" class="btn-indigo3">
                Ver Factura</a>  
                <a v-if="form2.file_url_fiscalizado" :href="form2.file_url_fiscalizado" class="btn-indigo3">
                Ver Respaldos</a>   
                  </div>
                 
              <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
                
                <loading-button :loading="form3.processing" class="btn-indigo" type="submit">Ingresar y Firmar</loading-button>
              </div>
            </form>
            </div>
            <div v-bind:class="{'hidden': openTab !== 4, 'block': openTab === 4}">
              <form @submit.prevent="updateFiscalizado">
                <div class="flex flex-wrap -mb-8 -mr-6 p-8">
               
                <textarea-input v-model="form2.detalle" :error="form2.errors.detalle" :req="form2.detalle" class="pb-8 pr-6 w-full lg:w-4/6" label="Observación" required />
                <file-input v-model="form2.foto_url" :error="form2.errors.foto_url" :req="form.foto2_url" class="pb-8 pr-6 w-full lg:w-2/6" type="file" label="Respaldos" required/>
                <a v-if="form2.file_url_fiscalizado" :href="form2.file_url_fiscalizado">Ver archivos</a>         
                  </div>
              <div v-if="form.tracking=='Fiscalizado' && $page.props.auth.user.rol =='Compras' && form.status_application=='Compras'" class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
                <loading-button :loading="form2.processing" class="btn-indigo" type="submit">Guardar respaldo firmado</loading-button>
              </div>
              </form>
            </div>
            <div v-bind:class="{'hidden': openTab !== 5, 'block': openTab === 5}">
            </div>
            <div v-bind:class="{'hidden': openTab !== 6, 'block': openTab === 6}">
              <form @submit.prevent="updateContablilidad">
                <div class="flex flex-wrap -mb-8 -mr-6 p-8">
                 
                <a :href="form.file_url" class="btn-indigo3">
                Ver Factura</a>  
                <a v-if="form2.file_url_fiscalizado" :href="form2.file_url_fiscalizado" class="btn-indigo3">
                Ver Respaldos</a>   
               
                  </div>
                
              <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
                <inertia-link class="btn-indigo3" :href="route('applicationbuy.pdfFiscalizado',form2.id)">
                  <span>Subir</span>
                  <span class="hidden md:inline"> Latinium</span>
                </inertia-link>  
    
              </div>
            </form>
            </div>
          </div>
        </div>
       
      </div>
    </div>
  </div>
   <!-- <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">  </div>-->
  </div>
</template>

<script>
import Layout from '@/Shared/LayoutMenu'
import FileInput from '@/Shared/FileInput'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import TextareaInput from '@/Shared/TextareaInput';



export default {
  metaInfo() {
    return {
      title: `${this.form.id}`,
    }
  },
  components: {
    FileInput,
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
    vSelect,
    DatePicker,
    TextareaInput,
  },
  layout: Layout,
  props: {
    contacts: Array,
    organizations: Array,
    application: Object,
    machinerys: Array,
  },
  remember: 'form',
  data() {
    return {
      openTab: 1,
      organizationes: this.organizations,
      contactos: this.contacts,
      machineryss: this.machinerys,
      form: this.$inertia.form({
        id: this.application.id,
        foto_url: null,
        total: this.application.total,
        number:this.application.number,
        fecha: this.application.fecha,
        tracking: this.application.tracking,
        status_application: this.application.status_application,
        detalle: this.application.detalle,
        organization_id: this.application.organization.name,
        contact_id: this.application.contact,
        machinery_id: this.application.machinery,
        file_url: this.application.file_url,
        kilometraje: this.application.kilometraje,
        upload: this.application.upload,
        estado_pago: this.application.estado_pago,
       tipo_pago: this.application.tipo_pago,

      }),
      form2: this.$inertia.form({
        id: this.application.id,
        detalle: this.application.detalle_fiscalizado,
        foto_url: null,
        file_url_fiscalizado: this.application.file_url_fiscalizado,
             
      }),
      form3: this.$inertia.form({
        id: this.application.id,
        total_pagar: this.application.total_pagar,
        tipo_destino: this.application.estado_pago,
        detalle_contable: this.application.detalle_contable,
                    
      }),
    }
  },
  methods: {
    toggleTabs: function(tabNumber){
      this.openTab = tabNumber
    },
    update() {
      this.form.post('/applicationbuyl')
    },
    updateFiscalizado() {
      this.form2.post('/applicationbuyFiscalizado')
   },
   updateContablilidad() {
      this.form3.post('/applicationbuyContabilidad')
   },
   updateFinanciero() {
      this.form4.post('/applicationbuyFinanciero')
   },
   updateArchivo() {
      this.form5.post('/applicationbuyArchivo')
   },
    destroy() {
      if (confirm('Está seguro de Eliminar esta Solicitud?')) {
        this.$inertia.delete(this.route('applicationbuy.destroy', this.application.id))
      }
    },
    restore() {
      if (confirm('Está seguro de Restaurar esta Solicitud?')) {
        this.$inertia.put(this.route('applicationbuy.restore', this.application.id))
      }
    },
  },
}
</script>